import React from 'react';
import './App.css';
import BackButton from './BackButton';

function FAQ() {
  /*
  This component displays a list of frequently asked questions (FAQ) related to the dealer photography app.
  */
  return (
    <div className="FAQ">
      <h1 className="FAQ-title">Frequently Asked Questions</h1>
      <div className="FAQ-list">
        <div className="FAQ-item">
          <div className="FAQ-question">Do we have to clear the parking lot?</div>
          <div className="FAQ-answer">
            Yes. This will give you a much better image without inventory and customer cars in front of your dealership.
          </div>
        </div>
        <div className="FAQ-item">
          <div className="FAQ-question">
            Will you send me the photos to review first before you implement them?
          </div>
          <div className="FAQ-answer">
            Absolutely! We value your opinion and will try to give you the best-looking custom image our team can create.
          </div>
        </div>
        <div className="FAQ-item">
          <div className="FAQ-question">
            Do we have to take the photos right now or can we wait for better weather?
          </div>
          <div className="FAQ-answer">
            Feel free to submit your images when it’s ideal for your location and time permits to clear your parking lot.
          </div>
        </div>
      </div>
      <BackButton />
    </div>
  );
}

export default FAQ;
